export {
  ANSWERS,
  RECOMMENDATION_QUESTION,
  greenAccept,
  redCross,
} from '~/pages/onboarding/quizBinaryChoice/libs/constants'

export const FOOT_BIOMECHANICS_QUESTION =
  'Want to learn about foot & biomechanics?'
export const DIGESTIVE_SYSTEM_QUESTION =
  'Want to learn about the digestive system?'
export const BRAIN_NERVOUS_SYSTEM_QUESTION =
  'Want to learn about the brain & nervous system?'
export const KIDNEYS_FILTRATION_QUESTION =
  'Want to learn about kidneys & filtration?'
export const LEARN_ANATOMY_QUESTION = 'Have you learned anatomy before?'
export const ANATOMY_SATISFIED_QUESTION =
  'Satisfied with what you know in anatomy?'
export const ANATOMY_FEELINGS_QUESTION = 'Does anatomy feel hard to learn?'
export const MOTIVATION_ANATOMY_QUESTION =
  'Is it easy for you to stay motivated while learning?'
export const PELVIC_FLOOR_QUESTION =
  'Did you know a strong pelvic floor reduces strain on your lower back and hips?'
export const BRAIN_PAIN_QUESTION =
  'Did you know that the brain lacks pain receptors, allowing awake surgery?'
